export type Language = 'en' | 'fr' | 'es' | 'nl';

export interface Translations {
  [key: string]: {
    en: string;
    fr: string;
    es: string;
    nl: string;
  };
}

export const translations: Translations = {
  // Navigation
  'nav.dashboard': {
    en: 'Dashboard',
    fr: 'Tableau de bord',
    es: 'Panel de control',
    nl: 'Dashboard'
  },
  'nav.inventory': {
    en: 'Inventory',
    fr: 'Inventaire',
    es: 'Inventario',
    nl: 'Voorraad'
  },
  'nav.sales': {
    en: 'Sales Invoices',
    fr: 'Factures de vente',
    es: 'Facturas de ventas',
    nl: 'Verkoopfacturen'
  },
  'nav.incoming': {
    en: 'Incoming Shipments',
    fr: 'Expéditions entrantes',
    es: 'Envíos entrantes',
    nl: 'Inkomende zendingen'
  },
  'nav.outgoing': {
    en: 'Outgoing Shipments',
    fr: 'Expéditions sortantes',
    es: 'Envíos salientes',
    nl: 'Uitgaande zendingen'
  },
  'nav.payment': {
    en: 'Payment Terminal',
    fr: 'Terminal de paiement',
    es: 'Terminal de pago',
    nl: 'Betaalterminal'
  },
  'nav.barcode': {
    en: 'Barcode Generator',
    fr: 'Générateur de codes-barres',
    es: 'Generador de códigos de barras',
    nl: 'Barcode generator'
  },
  'nav.reports': {
    en: 'Reports',
    fr: 'Rapports',
    es: 'Informes',
    nl: 'Rapporten'
  },
  'nav.settings': {
    en: 'Settings',
    fr: 'Paramètres',
    es: 'Configuración',
    nl: 'Instellingen'
  },
  'nav.admin': {
    en: 'Admin Panel',
    fr: 'Panneau d\'administration',
    es: 'Panel de administración',
    nl: 'Beheerpaneel'
  },
  'nav.users': {
    en: 'User Management',
    fr: 'Gestion des utilisateurs',
    es: 'Gestión de usuarios',
    nl: 'Gebruikersbeheer'
  },

  // Authentication
  'auth.login': {
    en: 'Sign In',
    fr: 'Se connecter',
    es: 'Iniciar sesión',
    nl: 'Inloggen'
  },
  'auth.logout': {
    en: 'Sign Out',
    fr: 'Se déconnecter',
    es: 'Cerrar sesión',
    nl: 'Uitloggen'
  },
  'auth.email': {
    en: 'Email Address',
    fr: 'Adresse e-mail',
    es: 'Correo electrónico',
    nl: 'E-mailadres'
  },
  'auth.password': {
    en: 'Password',
    fr: 'Mot de passe',
    es: 'Contraseña',
    nl: 'Wachtwoord'
  },
  'auth.welcome': {
    en: 'Welcome Back',
    fr: 'Bon retour',
    es: 'Bienvenido de nuevo',
    nl: 'Welkom terug'
  },
  'auth.signInAccount': {
    en: 'Sign in to your inventory management account',
    fr: 'Connectez-vous à votre compte de gestion d\'inventaire',
    es: 'Inicie sesión en su cuenta de gestión de inventario',
    nl: 'Log in op uw voorraadbeheeraccount'
  },

  // Common actions
  'action.add': {
    en: 'Add',
    fr: 'Ajouter',
    es: 'Agregar',
    nl: 'Toevoegen'
  },
  'action.edit': {
    en: 'Edit',
    fr: 'Modifier',
    es: 'Editar',
    nl: 'Bewerken'
  },
  'action.delete': {
    en: 'Delete',
    fr: 'Supprimer',
    es: 'Eliminar',
    nl: 'Verwijderen'
  },
  'action.save': {
    en: 'Save',
    fr: 'Enregistrer',
    es: 'Guardar',
    nl: 'Opslaan'
  },
  'action.cancel': {
    en: 'Cancel',
    fr: 'Annuler',
    es: 'Cancelar',
    nl: 'Annuleren'
  },
  'action.search': {
    en: 'Search',
    fr: 'Rechercher',
    es: 'Buscar',
    nl: 'Zoeken'
  },
  'action.filter': {
    en: 'Filter',
    fr: 'Filtrer',
    es: 'Filtrar',
    nl: 'Filteren'
  },
  'action.export': {
    en: 'Export',
    fr: 'Exporter',
    es: 'Exportar',
    nl: 'Exporteren'
  },
  'action.import': {
    en: 'Import',
    fr: 'Importer',
    es: 'Importar',
    nl: 'Importeren'
  },
  'action.refresh': {
    en: 'Refresh',
    fr: 'Actualiser',
    es: 'Actualizar',
    nl: 'Vernieuwen'
  },
  'action.print': {
    en: 'Print',
    fr: 'Imprimer',
    es: 'Imprimir',
    nl: 'Afdrukken'
  },

  // Product/Inventory
  'product.name': {
    en: 'Product Name',
    fr: 'Nom du produit',
    es: 'Nombre del producto',
    nl: 'Productnaam'
  },
  'product.sku': {
    en: 'SKU',
    fr: 'UGS',
    es: 'SKU',
    nl: 'SKU'
  },
  'product.barcode': {
    en: 'Barcode',
    fr: 'Code-barres',
    es: 'Código de barras',
    nl: 'Barcode'
  },
  'product.category': {
    en: 'Category',
    fr: 'Catégorie',
    es: 'Categoría',
    nl: 'Categorie'
  },
  'product.quantity': {
    en: 'Quantity',
    fr: 'Quantité',
    es: 'Cantidad',
    nl: 'Hoeveelheid'
  },
  'product.price': {
    en: 'Price',
    fr: 'Prix',
    es: 'Precio',
    nl: 'Prijs'
  },
  'product.cost': {
    en: 'Cost Price',
    fr: 'Prix de revient',
    es: 'Precio de costo',
    nl: 'Kostprijs'
  },
  'product.description': {
    en: 'Description',
    fr: 'Description',
    es: 'Descripción',
    nl: 'Beschrijving'
  },
  'product.inStock': {
    en: 'In Stock',
    fr: 'En stock',
    es: 'En stock',
    nl: 'Op voorraad'
  },
  'product.outOfStock': {
    en: 'Out of Stock',
    fr: 'Rupture de stock',
    es: 'Agotado',
    nl: 'Niet op voorraad'
  },
  'product.lowStock': {
    en: 'Low Stock',
    fr: 'Stock faible',
    es: 'Stock bajo',
    nl: 'Lage voorraad'
  },

  // User roles
  'role.super_admin': {
    en: 'Super Admin',
    fr: 'Super Administrateur',
    es: 'Super Administrador',
    nl: 'Super Beheerder'
  },
  'role.admin': {
    en: 'Admin',
    fr: 'Administrateur',
    es: 'Administrador',
    nl: 'Beheerder'
  },
  'role.worker': {
    en: 'Worker',
    fr: 'Travailleur',
    es: 'Trabajador',
    nl: 'Medewerker'
  },
  'role.viewer': {
    en: 'Viewer',
    fr: 'Observateur',
    es: 'Observador',
    nl: 'Kijker'
  },

  // Dashboard
  'dashboard.totalProducts': {
    en: 'Total Products',
    fr: 'Produits totaux',
    es: 'Productos totales',
    nl: 'Totaal producten'
  },
  'dashboard.totalSales': {
    en: 'Total Sales',
    fr: 'Ventes totales',
    es: 'Ventas totales',
    nl: 'Totaal verkopen'
  },
  'dashboard.lowStockItems': {
    en: 'Low Stock Items',
    fr: 'Articles en stock faible',
    es: 'Artículos con stock bajo',
    nl: 'Items met lage voorraad'
  },
  'dashboard.recentActivity': {
    en: 'Recent Activity',
    fr: 'Activité récente',
    es: 'Actividad reciente',
    nl: 'Recente activiteit'
  },

  // Settings
  'settings.language': {
    en: 'Language',
    fr: 'Langue',
    es: 'Idioma',
    nl: 'Taal'
  },
  'settings.theme': {
    en: 'Theme',
    fr: 'Thème',
    es: 'Tema',
    nl: 'Thema'
  },
  'settings.profileOld': {
    en: 'Profile',
    fr: 'Profil',
    es: 'Perfil',
    nl: 'Profiel'
  },
  'settings.account': {
    en: 'Account',
    fr: 'Compte',
    es: 'Cuenta',
    nl: 'Account'
  },

  // Welcome Page
  'welcome.title1': {
    en: 'Professional',
    fr: 'Professionnel',
    es: 'Profesional',
    nl: 'Professioneel'
  },
  'welcome.title2': {
    en: 'Inventory Management',
    fr: 'Gestion des stocks',
    es: 'Gestión de inventario',
    nl: 'Voorraadbeheer'
  },
  'welcome.subtitle': {
    en: 'Enterprise-grade inventory control with real-time tracking, automated workflows, and comprehensive analytics. Built for businesses that demand excellence.',
    fr: 'Contrôle des stocks de niveau entreprise avec suivi en temps réel, flux de travail automatisés et analyses complètes. Conçu pour les entreprises qui exigent l\'excellence.',
    es: 'Control de inventario de nivel empresarial con seguimiento en tiempo real, flujos de trabajo automatizados y análisis completos. Diseñado para empresas que exigen excelencia.',
    nl: 'Voorraadbeheer op ondernemingsniveau met realtime tracking, geautomatiseerde workflows en uitgebreide analyses. Gebouwd voor bedrijven die excellentie eisen.'
  },
  'welcome.accessSystem': {
    en: 'Access System',
    fr: 'Accéder au système',
    es: 'Acceder al sistema',
    nl: 'Toegang tot systeem'
  },
  'welcome.features.smart.title': {
    en: 'Smart Inventory',
    fr: 'Inventaire intelligent',
    es: 'Inventario inteligente',
    nl: 'Slim voorraadbeheer'
  },
  'welcome.features.smart.desc': {
    en: 'Real-time stock tracking with automated reorder points and low-stock alerts',
    fr: 'Suivi des stocks en temps réel avec points de réapprovisionnement automatisés et alertes de stock faible',
    es: 'Seguimiento de inventario en tiempo real con puntos de reorden automatizados y alertas de stock bajo',
    nl: 'Realtime voorraad tracking met geautomatiseerde herbestelpunten en lage-voorraad waarschuwingen'
  },
  'welcome.features.barcode.title': {
    en: 'Barcode Integration',
    fr: 'Intégration de codes-barres',
    es: 'Integración de códigos de barras',
    nl: 'Barcode integratie'
  },
  'welcome.features.barcode.desc': {
    en: 'Lightning-fast scanning with mobile support for efficient warehouse operations',
    fr: 'Numérisation ultra-rapide avec support mobile pour des opérations d\'entrepôt efficaces',
    es: 'Escaneo ultrarrápido con soporte móvil para operaciones de almacén eficientes',
    nl: 'Razendsnel scannen met mobiele ondersteuning voor efficiënte magazijnoperaties'
  },
  'welcome.features.analytics.title': {
    en: 'Advanced Analytics',
    fr: 'Analyses avancées',
    es: 'Análisis avanzado',
    nl: 'Geavanceerde analyses'
  },
  'welcome.features.analytics.desc': {
    en: 'Comprehensive reports and insights to optimize your inventory decisions',
    fr: 'Rapports et informations complets pour optimiser vos décisions d\'inventaire',
    es: 'Informes completos y análisis para optimizar sus decisiones de inventario',
    nl: 'Uitgebreide rapporten en inzichten om uw voorraad beslissingen te optimaliseren'
  },
  'welcome.features.team.title': {
    en: 'Team Collaboration',
    fr: 'Collaboration d\'équipe',
    es: 'Colaboración en equipo',
    nl: 'Teamsamenwerkng'
  },
  'welcome.features.team.desc': {
    en: 'Multi-user access with granular permissions and activity tracking',
    fr: 'Accès multi-utilisateurs avec autorisations granulaires et suivi d\'activité',
    es: 'Acceso multiusuario con permisos granulares y seguimiento de actividad',
    nl: 'Multi-gebruiker toegang met granulaire machtigingen en activiteit tracking'
  },
  'welcome.features.cloud.title': {
    en: 'Cloud Syncing',
    fr: 'Synchronisation cloud',
    es: 'Sincronización en la nube',
    nl: 'Cloud synchronisatie'
  },
  'welcome.features.cloud.desc': {
    en: 'Automatic synchronization across all devices with real-time updates',
    fr: 'Synchronisation automatique sur tous les appareils avec mises à jour en temps réel',
    es: 'Sincronización automática en todos los dispositivos con actualizaciones en tiempo real',
    nl: 'Automatische synchronisatie op alle apparaten met realtime updates'
  },
  'welcome.features.security.title': {
    en: 'Enterprise Security',
    fr: 'Sécurité d\'entreprise',
    es: 'Seguridad empresarial',
    nl: 'Ondernemingsbeveiliging'
  },
  'welcome.features.security.desc': {
    en: 'Bank-level encryption, role-based access, and comprehensive audit logs',
    fr: 'Chiffrement de niveau bancaire, accès basé sur les rôles et journaux d\'audit complets',
    es: 'Cifrado de nivel bancario, acceso basado en roles y registros de auditoría completos',
    nl: 'Encryptie op bankniveau, rolgebaseerde toegang en uitgebreide audit logs'
  },
  'welcome.metrics.stockErrors': {
    en: 'Reduction in Stock Errors',
    fr: 'Réduction des erreurs de stock',
    es: 'Reducción de errores de inventario',
    nl: 'Vermindering van voorraadfouten'
  },
  'welcome.metrics.processing': {
    en: 'Faster Processing',
    fr: 'Traitement plus rapide',
    es: 'Procesamiento más rápido',
    nl: 'Sneller verwerken'
  },
  'welcome.metrics.satisfaction': {
    en: 'Customer Satisfaction',
    fr: 'Satisfaction client',
    es: 'Satisfacción del cliente',
    nl: 'Klanttevredenheid'
  },
  'welcome.metrics.timeSaved': {
    en: 'Time Saved',
    fr: 'Temps économisé',
    es: 'Tiempo ahorrado',
    nl: 'Tijd bespaard'
  },
  'welcome.everything': {
    en: 'Everything You Need',
    fr: 'Tout ce dont vous avez besoin',
    es: 'Todo lo que necesitas',
    nl: 'Alles wat je nodig hebt'
  },
  'welcome.features.multi': {
    en: 'Multi-location inventory tracking',
    fr: 'Suivi des stocks multi-sites',
    es: 'Seguimiento de inventario en múltiples ubicaciones',
    nl: 'Multi-locatie voorraad tracking'
  },
  'welcome.features.automated': {
    en: 'Automated purchase orders',
    fr: 'Commandes d\'achat automatisées',
    es: 'Órdenes de compra automatizadas',
    nl: 'Geautomatiseerde inkooporders'
  },
  'welcome.features.supplier': {
    en: 'Supplier management',
    fr: 'Gestion des fournisseurs',
    es: 'Gestión de proveedores',
    nl: 'Leveranciersbeheer'
  },
  'welcome.features.custom': {
    en: 'Custom reporting dashboards',
    fr: 'Tableaux de bord de rapports personnalisés',
    es: 'Paneles de informes personalizados',
    nl: 'Aangepaste rapportage dashboards'
  },
  'welcome.features.mobile': {
    en: 'Mobile app for iOS & Android',
    fr: 'Application mobile pour iOS et Android',
    es: 'Aplicación móvil para iOS y Android',
    nl: 'Mobiele app voor iOS & Android'
  },
  'welcome.features.api': {
    en: 'API integration support',
    fr: 'Support d\'intégration API',
    es: 'Soporte de integración API',
    nl: 'API integratie ondersteuning'
  },
  'welcome.tech.security': {
    en: 'SOC2-ready with end-to-end encryption',
    fr: 'Compatible SOC2 avec chiffrement de bout en bout',
    es: 'Preparado para SOC2 con cifrado de extremo a extremo',
    nl: 'SOC2-gereed met end-to-end encryptie'
  },
  'welcome.tech.react': {
    en: 'Built with modern, maintainable technology',
    fr: 'Construit avec une technologie moderne et maintenable',
    es: 'Construido con tecnología moderna y mantenible',
    nl: 'Gebouwd met moderne, onderhoudbare technologie'
  },
  'welcome.tech.pwa': {
    en: 'Works offline, installs like native app',
    fr: 'Fonctionne hors ligne, s\'installe comme une application native',
    es: 'Funciona sin conexión, se instala como una aplicación nativa',
    nl: 'Werkt offline, installeert als native app'
  },
  'welcome.systemStatus': {
    en: 'System Status',
    fr: 'État du système',
    es: 'Estado del sistema',
    nl: 'Systeemstatus'
  },
  'welcome.status.database': {
    en: 'Database',
    fr: 'Base de données',
    es: 'Base de datos',
    nl: 'Database'
  },
  'welcome.status.security': {
    en: 'Security',
    fr: 'Sécurité',
    es: 'Seguridad',
    nl: 'Beveiliging'
  },
  'welcome.status.analytics': {
    en: 'Analytics',
    fr: 'Analyses',
    es: 'Análisis',
    nl: 'Analyses'
  },
  'welcome.status.scanning': {
    en: 'Scanning',
    fr: 'Numérisation',
    es: 'Escaneo',
    nl: 'Scannen'
  },
  'welcome.status.operational': {
    en: 'Operational',
    fr: 'Opérationnel',
    es: 'Operacional',
    nl: 'Operationeel'
  },
  'welcome.footer.built': {
    en: 'Built with modern web technologies',
    fr: 'Construit avec des technologies web modernes',
    es: 'Construido con tecnologías web modernas',
    nl: 'Gebouwd met moderne webtechnologieën'
  },
  'welcome.footer.creator': {
    en: 'Created by wiss',
    fr: 'Créé par wiss',
    es: 'Creado por wiss',
    nl: 'Gemaakt door wiss'
  },

  // Support Section
  'welcome.support.title': {
    en: 'Support Our Development',
    fr: 'Soutenez notre développement',
    es: 'Apoya nuestro desarrollo',
    nl: 'Steun onze ontwikkeling'
  },
  'welcome.support.description': {
    en: 'Help us build better features for you',
    fr: 'Aidez-nous à créer de meilleures fonctionnalités',
    es: 'Ayúdanos a crear mejores funciones',
    nl: 'Help ons betere functies te bouwen'
  },
  'welcome.support.button': {
    en: 'Support Us',
    fr: 'Nous soutenir',
    es: 'Apóyanos',
    nl: 'Steun ons'
  },

  // Integration Showcase
  'welcome.integrations.title': {
    en: 'Universal Hardware Compatibility',
    fr: 'Compatibilité matérielle universelle',
    es: 'Compatibilidad de hardware universal',
    nl: 'Universele hardwarecompatibiliteit'
  },
  'welcome.integrations.subtitle': {
    en: 'Works seamlessly with any device and scanner technology',
    fr: 'Fonctionne parfaitement avec tous les appareils et scanners',
    es: 'Funciona perfectamente con cualquier dispositivo y escáner',
    nl: 'Werkt naadloos met elk apparaat en scannertechnologie'
  },
  'welcome.integrations.scanner.title': {
    en: 'Any Scanner, Any Device',
    fr: 'Tous les scanners, tous les appareils',
    es: 'Cualquier escáner, cualquier dispositivo',
    nl: 'Elke scanner, elk apparaat'
  },
  'welcome.integrations.scanner.desc': {
    en: 'USB, Bluetooth, WiFi, Camera-based - works with all barcode scanner types on any device',
    fr: 'USB, Bluetooth, WiFi, Caméra - compatible avec tous les types de scanners sur tous les appareils',
    es: 'USB, Bluetooth, WiFi, Cámara - funciona con todos los tipos de escáneres en cualquier dispositivo',
    nl: 'USB, Bluetooth, WiFi, Camera - werkt met alle barcodescanners op elk apparaat'
  },
  'welcome.integrations.liveTracking.title': {
    en: 'Real-Time Live Tracking',
    fr: 'Suivi en temps réel',
    es: 'Seguimiento en tiempo real',
    nl: 'Live tracking in real-time'
  },
  'welcome.integrations.liveTracking.desc': {
    en: 'Monitor inventory changes instantly across all locations with live notifications and alerts',
    fr: 'Surveillez les changements instantanément avec notifications en direct',
    es: 'Monitoree cambios instantáneamente con notificaciones en vivo',
    nl: 'Monitor voorraadwijzigingen direct met live meldingen'
  },
  'welcome.integrations.notifications.title': {
    en: 'Smart Notifications',
    fr: 'Notifications intelligentes',
    es: 'Notificaciones inteligentes',
    nl: 'Slimme meldingen'
  },
  'welcome.integrations.notifications.desc': {
    en: 'Get instant alerts for low stock, new shipments, sales, and critical inventory events',
    fr: 'Alertes instantanées pour stock bas, nouvelles expéditions, ventes',
    es: 'Alertas instantáneas para stock bajo, nuevos envíos, ventas',
    nl: 'Ontvang directe waarschuwingen voor lage voorraad, zendingen'
  },
  'welcome.integrations.crossPlatform.title': {
    en: 'Works Everywhere',
    fr: 'Fonctionne partout',
    es: 'Funciona en todas partes',
    nl: 'Werkt overal'
  },
  'welcome.integrations.crossPlatform.desc': {
    en: 'Desktop, tablet, smartphone - full functionality on Windows, Mac, iOS, Android, and Linux',
    fr: 'Ordinateur, tablette, smartphone - fonctionne sur tous les systèmes',
    es: 'Escritorio, tableta, smartphone - funciona en todos los sistemas',
    nl: 'Desktop, tablet, smartphone - werkt op alle systemen'
  },
  'welcome.demo.title': {
    en: 'See It In Action',
    fr: 'Voyez-le en action',
    es: 'Véalo en acción',
    nl: 'Zie het in actie'
  },
  'welcome.demo.subtitle': {
    en: 'Lightning-fast barcode scanning with instant inventory updates',
    fr: 'Scan de codes-barres ultra-rapide avec mise à jour instantanée',
    es: 'Escaneo de códigos de barras ultrarrápido con actualización instantánea',
    nl: 'Razendsnel barcodescannen met directe voorraadupdate'
  },
  'welcome.tracking.title': {
    en: 'Automatic Package Tracking',
    fr: 'Suivi automatique des colis',
    es: 'Seguimiento automático de paquetes',
    nl: 'Automatische pakket tracking'
  },
  'welcome.tracking.subtitle': {
    en: 'Track all your shipments with real-time delivery status updates',
    fr: 'Suivez tous vos envois avec mises à jour en temps réel',
    es: 'Rastrea todos tus envíos con actualizaciones en tiempo real',
    nl: 'Volg al uw zendingen met real-time updates'
  },
  'welcome.tracking.autoTracking': {
    en: 'Automatically track packages from all major carriers worldwide',
    fr: 'Suivi automatique avec tous les transporteurs majeurs',
    es: 'Seguimiento automático con todos los transportistas principales',
    nl: 'Automatisch volgen bij alle grote vervoerders wereldwijd'
  },
  'welcome.tracking.realtimeUpdates': {
    en: 'Real-time delivery status and location updates',
    fr: 'Statut de livraison et localisation en temps réel',
    es: 'Estado de entrega y ubicación en tiempo real',
    nl: 'Real-time bezorgstatus en locatie updates'
  },
  'welcome.tracking.notifications': {
    en: 'Smart notifications for delivery milestones and exceptions',
    fr: 'Notifications intelligentes pour étapes et exceptions',
    es: 'Notificaciones inteligentes para hitos y excepciones',
    nl: 'Slimme meldingen voor bezorg-updates en uitzonderingen'
  },
  'welcome.tracking.customerShare': {
    en: 'Share tracking links directly with your customers',
    fr: 'Partagez liens de suivi avec vos clients',
    es: 'Comparte enlaces de seguimiento con tus clientes',
    nl: 'Deel tracking links direct met uw klanten'
  },

  'auth.createAccount': {
    en: 'Create Account',
    fr: 'Créer un compte',
    es: 'Crear cuenta',
    nl: 'Account aanmaken'
  },
  'auth.fullName': {
    en: 'Full Name',
    fr: 'Nom complet',
    es: 'Nombre completo',
    nl: 'Volledige naam'
  },
  'auth.enterFullName': {
    en: 'Enter your full name',
    fr: 'Entrez votre nom complet',
    es: 'Ingrese su nombre completo',
    nl: 'Voer uw volledige naam in'
  },
  'auth.enterEmail': {
    en: 'Enter your email',
    fr: 'Entrez votre email',
    es: 'Ingrese su correo electrónico',
    nl: 'Voer uw e-mail in'
  },
  'auth.enterPassword': {
    en: 'Enter your password',
    fr: 'Entrez votre mot de passe',
    es: 'Ingrese su contraseña',
    nl: 'Voer uw wachtwoord in'
  },
  'auth.noAccount': {
    en: 'Don\'t have an account? Sign up',
    fr: 'Vous n\'avez pas de compte ? Inscrivez-vous',
    es: '¿No tienes una cuenta? Regístrate',
    nl: 'Geen account? Meld u aan'
  },
  'auth.haveAccount': {
    en: 'Already have an account? Sign in',
    fr: 'Vous avez déjà un compte ? Connectez-vous',
    es: '¿Ya tienes una cuenta? Inicia sesión',
    nl: 'Al een account? Log in'
  },

  // Messages
  'message.success': {
    en: 'Success',
    fr: 'Succès',
    es: 'Éxito',
    nl: 'Succes'
  },
  'message.error': {
    en: 'Error',
    fr: 'Erreur',
    es: 'Error',
    nl: 'Fout'
  },
  'message.loading': {
    en: 'Loading...',
    fr: 'Chargement...',
    es: 'Cargando...',
    nl: 'Laden...'
  },
  'message.noData': {
    en: 'No data available',
    fr: 'Aucune donnée disponible',
    es: 'No hay datos disponibles',
    nl: 'Geen gegevens beschikbaar'
  },
  'message.confirmDelete': {
    en: 'Are you sure you want to delete this item?',
    fr: 'Êtes-vous sûr de vouloir supprimer cet élément ?',
    es: '¿Está seguro de que desea eliminar este elemento?',
    nl: 'Weet u zeker dat u dit item wilt verwijderen?'
  },

  // Reports & Analytics
  'reports.title': { en: 'Reports & Analytics', fr: 'Rapports et analyses', es: 'Informes y análisis', nl: 'Rapporten & Analyses' },
  'reports.subtitle': { en: 'Comprehensive insights and data analysis', fr: 'Aperçus complets et analyse des données', es: 'Información completa y análisis de datos', nl: 'Uitgebreide inzichten en data-analyse' },
  'reports.tabs.overview': { en: 'Overview', fr: 'Vue d\'ensemble', es: 'Resumen', nl: 'Overzicht' },
  'reports.tabs.shipments': { en: 'Shipments', fr: 'Expéditions', es: 'Envíos', nl: 'Zendingen' },
  'reports.tabs.activity': { en: 'Activity Log', fr: 'Journal d\'activité', es: 'Registro de actividad', nl: 'Activiteitenlog' },
  'reports.tabs.analysis': { en: 'Analysis', fr: 'Analyse', es: 'Análisis', nl: 'Analyse' },
  'reports.tabs.invoices': { en: 'Sales Invoices', fr: 'Factures de vente', es: 'Facturas de ventas', nl: 'Verkoopfacturen' },
  'reports.tabs.workerFulfillment': { en: 'Worker Fulfillment', fr: 'Exécution par opérateur', es: 'Cumplimiento por trabajador', nl: 'Werknemerafhandeling' },
  'reports.workerFulfillment.title': { en: 'Worker Fulfillment', fr: 'Exécution par opérateur', es: 'Cumplimiento por trabajador', nl: 'Werknemerafhandeling' },
  'reports.workerFulfillment.subtitle': { en: 'Picked/ready and Shopify fulfilled performance by worker', fr: 'Performance prêt/ramassé et expédié Shopify par opérateur', es: 'Rendimiento listo/recogido y cumplido Shopify por trabajador', nl: 'Prestaties klaar/gepicked en Shopify vervuld per werknemer' },
  'reports.workerFulfillment.ready': { en: 'Ready (Picked)', fr: 'Prêt (ramassé)', es: 'Listo (recogido)', nl: 'Klaar (gepicked)' },
  'reports.workerFulfillment.fulfilled': { en: 'Shopify Fulfilled', fr: 'Expédié Shopify', es: 'Cumplido Shopify', nl: 'Shopify vervuld' },
  'reports.workerFulfillment.target': { en: 'Target: 100 per 8-hour shift (scaled by selected range)', fr: 'Objectif : 100 par poste de 8 h (ajusté à la période)', es: 'Objetivo: 100 por turno de 8 h (escalado por el rango)', nl: 'Doel: 100 per 8-urige dienst (geschaald op geselecteerde periode)' },
  'reports.workerFulfillment.last1Hour': { en: 'Last 1 hour', fr: 'Dernière heure', es: 'Última hora', nl: 'Laatste uur' },
  'reports.workerFulfillment.last1Day': { en: 'Last 1 day', fr: 'Dernier jour', es: 'Último día', nl: 'Laatste dag' },
  'reports.workerFulfillment.last7Days': { en: 'Last 7 days', fr: '7 derniers jours', es: 'Últimos 7 días', nl: 'Laatste 7 dagen' },
  'reports.stats.totalItems': { en: 'Total Items', fr: 'Articles totaux', es: 'Artículos totales', nl: 'Totaal artikelen' },
  'reports.stats.totalQuantity': { en: 'Total Quantity', fr: 'Quantité totale', es: 'Cantidad total', nl: 'Totale hoeveelheid' },
  'reports.stats.lowStock': { en: 'Low Stock', fr: 'Stock faible', es: 'Stock bajo', nl: 'Lage voorraad' },
  'reports.stats.totalValue': { en: 'Total Value', fr: 'Valeur totale', es: 'Valor total', nl: 'Totale waarde' },
  'reports.categoryBreakdown': { en: 'Category Breakdown', fr: 'Répartition par catégorie', es: 'Desglose por categoría', nl: 'Categorie overzicht' },
  'reports.items': { en: 'Items', fr: 'Articles', es: 'Artículos', nl: 'Artikelen' },
  'reports.quantity': { en: 'Quantity', fr: 'Quantité', es: 'Cantidad', nl: 'Hoeveelheid' },
  'reports.value': { en: 'Value', fr: 'Valeur', es: 'Valor', nl: 'Waarde' },
  'reports.buyValue': { en: 'Buy Value', fr: 'Valeur d\'achat', es: 'Valor de compra', nl: 'Inkoopwaarde' },
  'reports.sellValue': { en: 'Sell Value', fr: 'Valeur de vente', es: 'Valor de venta', nl: 'Verkoopwaarde' },
  'reports.potentialProfit': { en: 'Potential Profit', fr: 'Profit potentiel', es: 'Beneficio potencial', nl: 'Potentiële winst' },
  'reports.shipmentHistory': { en: 'Shipment History', fr: 'Historique des expéditions', es: 'Historial de envíos', nl: 'Zendinggeschiedenis' },
  'reports.incomingShipments': { en: 'Incoming Shipments', fr: 'Expéditions entrantes', es: 'Envíos entrantes', nl: 'Inkomende zendingen' },
  'reports.outgoingShipments': { en: 'Outgoing Shipments', fr: 'Expéditions sortantes', es: 'Envíos salientes', nl: 'Uitgaande zendingen' },
  'reports.incoming': { en: 'Incoming', fr: 'Entrant', es: 'Entrante', nl: 'Inkomend' },
  'reports.outgoing': { en: 'Outgoing', fr: 'Sortant', es: 'Saliente', nl: 'Uitgaand' },
  'reports.completed': { en: 'Completed', fr: 'Terminé', es: 'Completado', nl: 'Voltooid' },
  'reports.noShipments': { en: 'No shipments yet', fr: 'Aucune expédition pour le moment', es: 'Aún no hay envíos', nl: 'Nog geen zendingen' },
  'reports.activityLog': { en: 'Activity Log', fr: 'Journal d\'activité', es: 'Registro de actividad', nl: 'Activiteitenlog' },
  'reports.noActivity': { en: 'No activity recorded yet', fr: 'Aucune activité enregistrée', es: 'Aún no se ha registrado actividad', nl: 'Nog geen activiteit geregistreerd' },
  'reports.visualAnalysis': { en: 'Visual Analysis', fr: 'Analyse visuelle', es: 'Análisis visual', nl: 'Visuele analyse' },
  'reports.performanceMetrics': { en: 'Performance Metrics', fr: 'Indicateurs de performance', es: 'Métricas de rendimiento', nl: 'Prestatie-indicatoren' },
  'reports.stockTurnover': { en: 'Stock Turnover', fr: 'Rotation des stocks', es: 'Rotación de inventario', nl: 'Voorraadrotatie' },
  'reports.orderFulfillment': { en: 'Order Fulfillment', fr: 'Exécution des commandes', es: 'Cumplimiento de pedidos', nl: 'Ordervervulling' },
  'reports.inventoryAccuracy': { en: 'Inventory Accuracy', fr: 'Précision de l\'inventaire', es: 'Precisión del inventario', nl: 'Voorraadnauwkeurigheid' },
  'reports.trends': { en: 'Trends', fr: 'Tendances', es: 'Tendencias', nl: 'Trends' },
  'reports.salesGrowth': { en: 'Sales Growth', fr: 'Croissance des ventes', es: 'Crecimiento de ventas', nl: 'Verkoopgroei' },
  'reports.inventoryValue': { en: 'Inventory Value', fr: 'Valeur de l\'inventaire', es: 'Valor del inventario', nl: 'Voorraadwaarde' },
  'reports.stockouts': { en: 'Stockouts', fr: 'Ruptures de stock', es: 'Falta de existencias', nl: 'Uitverkocht' },
  'reports.salesInvoices': { en: 'Sales Invoices', fr: 'Factures de vente', es: 'Facturas de ventas', nl: 'Verkoopfacturen' },
  'reports.totalInvoices': { en: 'Total Invoices', fr: 'Factures totales', es: 'Facturas totales', nl: 'Totaal facturen' },
  'reports.totalRevenue': { en: 'Total Revenue', fr: 'Revenu total', es: 'Ingresos totales', nl: 'Totale omzet' },
  'reports.pendingPayments': { en: 'Pending Payments', fr: 'Paiements en attente', es: 'Pagos pendientes', nl: 'Openstaande betalingen' },
  'reports.avgInvoiceValue': { en: 'Avg. Invoice Value', fr: 'Valeur moyenne de facture', es: 'Valor promedio de factura', nl: 'Gem. factuurwaarde' },
  'reports.noInvoices': { en: 'No invoices yet', fr: 'Aucune facture pour le moment', es: 'Aún no hay facturas', nl: 'Nog geen facturen' },
  'reports.invoicesFromTerminal': { en: 'Invoices from the Payment Terminal will appear here', fr: 'Les factures du terminal de paiement apparaîtront ici', es: 'Las facturas del terminal de pago aparecerán aquí', nl: 'Facturen van de betaalterminal verschijnen hier' },
  'reports.table.date': { en: 'Date', fr: 'Date', es: 'Fecha', nl: 'Datum' },
  'reports.table.type': { en: 'Type', fr: 'Type', es: 'Tipo', nl: 'Type' },
  'reports.table.items': { en: 'Items', fr: 'Articles', es: 'Artículos', nl: 'Artikelen' },
  'reports.table.status': { en: 'Status', fr: 'Statut', es: 'Estado', nl: 'Status' },
  'reports.table.invoiceNumber': { en: 'Invoice #', fr: 'Facture n°', es: 'Factura n°', nl: 'Factuur #' },
  'reports.table.customer': { en: 'Customer', fr: 'Client', es: 'Cliente', nl: 'Klant' },
  'reports.table.amount': { en: 'Amount', fr: 'Montant', es: 'Monto', nl: 'Bedrag' },
  'reports.table.payment': { en: 'Payment', fr: 'Paiement', es: 'Pago', nl: 'Betaling' },

  // Dashboard translations
  'dashboard.welcomeMessage': { en: 'Welcome to your inventory management dashboard', fr: 'Bienvenue sur votre tableau de bord de gestion des stocks', es: 'Bienvenido a tu panel de gestión de inventario', nl: 'Welkom bij je voorraadbeheer dashboard' },
  'dashboard.offlineMode': { en: 'Offline Mode', fr: 'Mode hors ligne', es: 'Modo sin conexión', nl: 'Offline modus' },
  'dashboard.systemOnline': { en: 'System Online', fr: 'Système en ligne', es: 'Sistema en línea', nl: 'Systeem online' },
  'dashboard.superAdminPanel': { en: 'Super Admin Panel', fr: 'Panneau super administrateur', es: 'Panel de super administrador', nl: 'Super beheerderspaneel' },
  'dashboard.userManagement': { en: 'User Management', fr: 'Gestion des utilisateurs', es: 'Gestión de usuarios', nl: 'Gebruikersbeheer' },
  'dashboard.totalItems': { en: 'Total Items', fr: 'Articles totaux', es: 'Artículos totales', nl: 'Totaal artikelen' },
  'dashboard.totalQuantity': { en: 'Total Quantity', fr: 'Quantité totale', es: 'Cantidad total', nl: 'Totale hoeveelheid' },
  'dashboard.lowStock': { en: 'Low Stock', fr: 'Stock faible', es: 'Stock bajo', nl: 'Lage voorraad' },
  'dashboard.categories': { en: 'Categories', fr: 'Catégories', es: 'Categorías', nl: 'Categorieën' },
  'dashboard.inventoryValue': { en: 'Inventory Value', fr: 'Valeur de l\'inventaire', es: 'Valor del inventario', nl: 'Voorraadwaarde' },
  'dashboard.costValue': { en: 'Cost Value', fr: 'Valeur de coût', es: 'Valor de costo', nl: 'Kostwaarde' },
  'dashboard.sellValue': { en: 'Sell Value', fr: 'Valeur de vente', es: 'Valor de venta', nl: 'Verkoopwaarde' },
  'dashboard.potentialProfit': { en: 'Potential Profit', fr: 'Profit potentiel', es: 'Beneficio potencial', nl: 'Potentiële winst' },
  'dashboard.shipments': { en: 'Shipments', fr: 'Expéditions', es: 'Envíos', nl: 'Zendingen' },
  'dashboard.incoming': { en: 'Incoming', fr: 'Entrant', es: 'Entrante', nl: 'Inkomend' },
  'dashboard.outgoing': { en: 'Outgoing', fr: 'Sortant', es: 'Saliente', nl: 'Uitgaand' },
  'dashboard.systemStatus': { en: 'System Status', fr: 'État du système', es: 'Estado del sistema', nl: 'Systeemstatus' },
  'dashboard.status': { en: 'Status', fr: 'Statut', es: 'Estado', nl: 'Status' },
  'dashboard.role': { en: 'Role', fr: 'Rôle', es: 'Rol', nl: 'Rol' },
  'dashboard.quickActions': { en: 'Quick Actions', fr: 'Actions rapides', es: 'Acciones rápidas', nl: 'Snelle acties' },
  'dashboard.scanBarcode': { en: 'Scan Barcode', fr: 'Scanner le code-barres', es: 'Escanear código de barras', nl: 'Scan barcode' },
  'dashboard.quickBarcodeScanning': { en: 'Quick barcode scanning', fr: 'Numérisation rapide de codes-barres', es: 'Escaneo rápido de códigos de barras', nl: 'Snel barcode scannen' },
  'dashboard.addNewItem': { en: 'Add New Item', fr: 'Ajouter un nouvel article', es: 'Agregar nuevo artículo', nl: 'Nieuw item toevoegen' },
  'dashboard.addItemsToInventory': { en: 'Add items to inventory', fr: 'Ajouter des articles à l\'inventaire', es: 'Agregar artículos al inventario', nl: 'Items toevoegen aan voorraad' },
  'dashboard.processSales': { en: 'Process sales', fr: 'Traiter les ventes', es: 'Procesar ventas', nl: 'Verkoop verwerken' },
  'dashboard.createInvoice': { en: 'Create Invoice', fr: 'Créer une facture', es: 'Crear factura', nl: 'Factuur maken' },
  'dashboard.generateSalesInvoice': { en: 'Generate sales invoice', fr: 'Générer une facture de vente', es: 'Generar factura de ventas', nl: 'Verkoopfactuur genereren' },
  'dashboard.incomingShipment': { en: 'Incoming Shipment', fr: 'Expédition entrante', es: 'Envío entrante', nl: 'Inkomende zending' },
  'dashboard.receiveNewStock': { en: 'Receive new stock', fr: 'Recevoir un nouveau stock', es: 'Recibir nuevo stock', nl: 'Nieuwe voorraad ontvangen' },
  'dashboard.viewReports': { en: 'View Reports', fr: 'Voir les rapports', es: 'Ver informes', nl: 'Rapporten bekijken' },
  'dashboard.analyticsInsights': { en: 'Analytics & insights', fr: 'Analyses et informations', es: 'Análisis e información', nl: 'Analyses & inzichten' },
  'dashboard.recentInventoryItems': { en: 'Recent Inventory Items', fr: 'Articles d\'inventaire récents', es: 'Artículos de inventario recientes', nl: 'Recente voorraad items' },
  'dashboard.viewAll': { en: 'View All', fr: 'Voir tout', es: 'Ver todo', nl: 'Alles bekijken' },
  'dashboard.noInventoryItems': { en: 'No inventory items yet', fr: 'Aucun article d\'inventaire pour le moment', es: 'Aún no hay artículos de inventario', nl: 'Nog geen voorraad items' },
  'dashboard.addFirstItem': { en: 'Add First Item', fr: 'Ajouter le premier article', es: 'Agregar primer artículo', nl: 'Eerste item toevoegen' },
  'dashboard.noLocation': { en: 'No location', fr: 'Aucun emplacement', es: 'Sin ubicación', nl: 'Geen locatie' },
  'dashboard.lowStockAlert': { en: 'Low Stock Alert', fr: 'Alerte de stock faible', es: 'Alerta de stock bajo', nl: 'Lage voorraad waarschuwing' },
  'dashboard.left': { en: 'left', fr: 'restant', es: 'restante', nl: 'over' },
  'dashboard.manageStockLevels': { en: 'Manage Stock Levels', fr: 'Gérer les niveaux de stock', es: 'Gestionar niveles de stock', nl: 'Voorraadniveaus beheren' },
  'dashboard.systemInformation': { en: 'System Information', fr: 'Informations système', es: 'Información del sistema', nl: 'Systeeminformatie' },
  'dashboard.account': { en: 'Account', fr: 'Compte', es: 'Cuenta', nl: 'Account' },
  'dashboard.plan': { en: 'Plan', fr: 'Plan', es: 'Plan', nl: 'Plan' },
  'dashboard.expires': { en: 'Expires', fr: 'Expire', es: 'Expira', nl: 'Verloopt' },
  'dashboard.features': { en: 'Features', fr: 'Fonctionnalités', es: 'Características', nl: 'Functies' },
  'dashboard.pricing': { en: 'Pricing', fr: 'Tarification', es: 'Precios', nl: 'Prijzen' },
  'dashboard.enabled': { en: 'Enabled', fr: 'Activé', es: 'Habilitado', nl: 'Ingeschakeld' },
  'dashboard.disabled': { en: 'Disabled', fr: 'Désactivé', es: 'Deshabilitado', nl: 'Uitgeschakeld' },
  'dashboard.taxRate': { en: 'Tax Rate', fr: 'Taux de taxe', es: 'Tasa de impuestos', nl: 'BTW-tarief' },
  'dashboard.paymentTerms': { en: 'Payment Terms', fr: 'Conditions de paiement', es: 'Términos de pago', nl: 'Betalingsvoorwaarden' },
  'dashboard.days': { en: 'days', fr: 'jours', es: 'días', nl: 'dagen' },
  'dashboard.usage': { en: 'Usage', fr: 'Utilisation', es: 'Uso', nl: 'Gebruik' },
  'dashboard.itemsAdded': { en: 'Items Added', fr: 'Articles ajoutés', es: 'Artículos agregados', nl: 'Items toegevoegd' },
  'dashboard.incomingStock': { en: 'Incoming Stock', fr: 'Stock entrant', es: 'Stock entrante', nl: 'Inkomende voorraad' },
  'dashboard.outgoingStock': { en: 'Outgoing Stock', fr: 'Stock sortant', es: 'Stock saliente', nl: 'Uitgaande voorraad' },
  'dashboard.totalInventory': { en: 'Total Inventory', fr: 'Inventaire total', es: 'Inventario total', nl: 'Totale voorraad' },

  // Inventory page translations
  'inventory.title': { en: 'Inventory Management', fr: 'Gestion des stocks', es: 'Gestión de inventario', nl: 'Voorraadbeheer' },
  'inventory.subtitle': { en: 'Manage your products and stock levels', fr: 'Gérez vos produits et niveaux de stock', es: 'Gestiona tus productos y niveles de stock', nl: 'Beheer je producten en voorraadniveaus' },
  'inventory.addItem': { en: 'Add Item', fr: 'Ajouter un article', es: 'Agregar artículo', nl: 'Item toevoegen' },
  'inventory.searchPlaceholder': { en: 'Search by name, SKU, or barcode...', fr: 'Rechercher par nom, UGS ou code-barres...', es: 'Buscar por nombre, SKU o código de barras...', nl: 'Zoek op naam, SKU of barcode...' },
  'inventory.allCategories': { en: 'All Categories', fr: 'Toutes les catégories', es: 'Todas las categorías', nl: 'Alle categorieën' },
  'inventory.table.name': { en: 'Name', fr: 'Nom', es: 'Nombre', nl: 'Naam' },
  'inventory.table.sku': { en: 'SKU', fr: 'UGS', es: 'SKU', nl: 'SKU' },
  'inventory.table.category': { en: 'Category', fr: 'Catégorie', es: 'Categoría', nl: 'Categorie' },
  'inventory.table.quantity': { en: 'Quantity', fr: 'Quantité', es: 'Cantidad', nl: 'Hoeveelheid' },
  'inventory.table.location': { en: 'Location', fr: 'Emplacement', es: 'Ubicación', nl: 'Locatie' },
  'inventory.table.price': { en: 'Price', fr: 'Prix', es: 'Precio', nl: 'Prijs' },
  'inventory.table.actions': { en: 'Actions', fr: 'Actions', es: 'Acciones', nl: 'Acties' },
  'inventory.noItems': { en: 'No inventory items found', fr: 'Aucun article d\'inventaire trouvé', es: 'No se encontraron artículos de inventario', nl: 'Geen voorraad items gevonden' },
  'inventory.editItem': { en: 'Edit Item', fr: 'Modifier l\'article', es: 'Editar artículo', nl: 'Item bewerken' },
  'inventory.addNewItem': { en: 'Add New Item', fr: 'Ajouter un nouvel article', es: 'Agregar nuevo artículo', nl: 'Nieuw item toevoegen' },
  'inventory.itemName': { en: 'Item Name', fr: 'Nom de l\'article', es: 'Nombre del artículo', nl: 'Item naam' },
  'inventory.enterItemName': { en: 'Enter item name', fr: 'Entrez le nom de l\'article', es: 'Ingrese el nombre del artículo', nl: 'Voer item naam in' },
  'inventory.enterCategory': { en: 'e.g., Electronics, Tools', fr: 'ex. Électronique, Outils', es: 'ej. Electrónica, Herramientas', nl: 'bijv. Elektronica, Gereedschap' },
  'inventory.warehouseLocation': { en: 'Warehouse A, Shelf 1', fr: 'Entrepôt A, Étagère 1', es: 'Almacén A, Estante 1', nl: 'Magazijn A, Schap 1' },
  'inventory.batchNumber': { en: 'Batch Number', fr: 'Numéro de lot', es: 'Número de lote', nl: 'Batchnummer' },
  'inventory.enterOrScan': { en: 'Enter or scan batch number', fr: 'Entrez ou scannez le numéro de lot', es: 'Ingrese o escanee el número de lote', nl: 'Voer batchnummer in of scan' },
  'inventory.safetyCategory': { en: 'Safety Category', fr: 'Catégorie de sécurité', es: 'Categoría de seguridad', nl: 'Veiligheidscategorie' },
  'inventory.noSafetyCategory': { en: 'No safety category', fr: 'Aucune catégorie de sécurité', es: 'Sin categoría de seguridad', nl: 'Geen veiligheidscategorie' },
  'inventory.flammable': { en: 'Flammable', fr: 'Inflammable', es: 'Inflamable', nl: 'Brandbaar' },
  'inventory.toxic': { en: 'Toxic', fr: 'Toxique', es: 'Tóxico', nl: 'Giftig' },
  'inventory.corrosive': { en: 'Corrosive', fr: 'Corrosif', es: 'Corrosivo', nl: 'Bijtend' },
  'inventory.explosive': { en: 'Explosive', fr: 'Explosif', es: 'Explosivo', nl: 'Explosief' },
  'inventory.oxidizing': { en: 'Oxidizing', fr: 'Oxydant', es: 'Oxidante', nl: 'Oxiderend' },
  'inventory.compressedGas': { en: 'Compressed Gas', fr: 'Gaz comprimé', es: 'Gas comprimido', nl: 'Gecomprimeerd gas' },
  'inventory.radioactive': { en: 'Radioactive', fr: 'Radioactif', es: 'Radioactivo', nl: 'Radioactief' },
  'inventory.biohazard': { en: 'Biohazard', fr: 'Biohazard', es: 'Biopeligro', nl: 'Biogevaar' },
  'inventory.scanBarcodeTitle': { en: 'Scan Barcode for Item', fr: 'Scanner le code-barres pour l\'article', es: 'Escanear código de barras del artículo', nl: 'Scan barcode voor item' },
  'inventory.updateItem': { en: 'Update Item', fr: 'Mettre à jour l\'article', es: 'Actualizar artículo', nl: 'Item bijwerken' },
  'inventory.stock': { en: 'Stock', fr: 'Stock', es: 'Stock', nl: 'Voorraad' },

  // Payment Terminal translations
  'payment.title': { en: 'Payment Terminal', fr: 'Terminal de paiement', es: 'Terminal de pago', nl: 'Betaalterminal' },
  'payment.subtitle': { en: 'Process sales and generate invoices', fr: 'Traiter les ventes et générer des factures', es: 'Procesar ventas y generar facturas', nl: 'Verkoop verwerken en facturen genereren' },
  'payment.scanItem': { en: 'Scan Item', fr: 'Scanner l\'article', es: 'Escanear artículo', nl: 'Item scannen' },
  'payment.cart': { en: 'Cart', fr: 'Panier', es: 'Carrito', nl: 'Winkelwagen' },
  'payment.total': { en: 'Total', fr: 'Total', es: 'Total', nl: 'Totaal' },
  'payment.checkout': { en: 'Checkout', fr: 'Paiement', es: 'Pagar', nl: 'Afrekenen' },
  'payment.cash': { en: 'Cash', fr: 'Espèces', es: 'Efectivo', nl: 'Contant' },
  'payment.card': { en: 'Card', fr: 'Carte', es: 'Tarjeta', nl: 'Kaart' },
  'payment.emptyCart': { en: 'Cart is empty', fr: 'Le panier est vide', es: 'El carrito está vacío', nl: 'Winkelwagen is leeg' },

  // Shipments translations
  'shipments.incoming.title': { en: 'Incoming Shipments', fr: 'Expéditions entrantes', es: 'Envíos entrantes', nl: 'Inkomende zendingen' },
  'shipments.outgoing.title': { en: 'Outgoing Shipments', fr: 'Expéditions sortantes', es: 'Envíos salientes', nl: 'Uitgaande zendingen' },
  'shipments.create': { en: 'Create Shipment', fr: 'Créer une expédition', es: 'Crear envío', nl: 'Zending maken' },
  'shipments.reference': { en: 'Reference', fr: 'Référence', es: 'Referencia', nl: 'Referentie' },
  'shipments.items': { en: 'Items', fr: 'Articles', es: 'Artículos', nl: 'Items' },
  'shipments.date': { en: 'Date', fr: 'Date', es: 'Fecha', nl: 'Datum' },
  'shipments.noShipments': { en: 'No shipments found', fr: 'Aucune expédition trouvée', es: 'No se encontraron envíos', nl: 'Geen zendingen gevonden' },

  // Barcode Generator translations
  'barcode.title': { en: 'Code Generator', fr: 'Générateur de codes', es: 'Generador de códigos', nl: 'Code generator' },
  'barcode.subtitle': { en: 'Generate and print product barcodes', fr: 'Générer et imprimer des codes-barres de produits', es: 'Generar e imprimir códigos de barras de productos', nl: 'Genereer en print product barcodes' },
  'barcode.selectProduct': { en: 'Select Product', fr: 'Sélectionner le produit', es: 'Seleccionar producto', nl: 'Product selecteren' },
  'barcode.generate': { en: 'Generate Barcode', fr: 'Générer le code-barres', es: 'Generar código de barras', nl: 'Barcode genereren' },
  'barcode.generateQR': { en: 'Generate QR Code', fr: 'Générer le code QR', es: 'Generar código QR', nl: 'QR code genereren' },
  'barcode.download': { en: 'Download', fr: 'Télécharger', es: 'Descargar', nl: 'Downloaden' },
  'barcode.barcodeLabel': { en: 'Barcode', fr: 'Code-barres', es: 'Código de barras', nl: 'Barcode' },
  'barcode.qrcodeLabel': { en: 'QR Code', fr: 'Code QR', es: 'Código QR', nl: 'QR code' },
  'barcode.subtitleGenerate': { en: 'for inventory items with integrated labeling', fr: 'pour les articles d\'inventaire avec étiquetage intégré', es: 'para artículos de inventario con etiquetado integrado', nl: 'voor voorraad items met geïntegreerde etikettering' },
  'barcode.subtitleBarcode': { en: 'barcodes', fr: 'codes-barres', es: 'códigos de barras', nl: 'barcodes' },
  'barcode.subtitleQR': { en: 'QR codes', fr: 'codes QR', es: 'códigos QR', nl: 'QR codes' },
  'barcode.generateNew': { en: 'Generate New', fr: 'Générer un nouveau', es: 'Generar nuevo', nl: 'Genereer nieuwe' },
  'barcode.clickToGenerate': { en: 'Click "Generate" to create a new code', fr: 'Cliquez sur "Générer" pour créer un nouveau code', es: 'Haga clic en "Generar" para crear un nuevo código', nl: 'Klik op "Genereren" om een nieuwe code te maken' },
  'barcode.generated': { en: 'Generated', fr: 'Généré', es: 'Generado', nl: 'Gegenereerd' },
  'barcode.createWithItem': { en: 'Create Item with Code', fr: 'Créer un article avec code', es: 'Crear artículo con código', nl: 'Item maken met code' },
  'barcode.optionalInfo': { en: 'Optional item information', fr: 'Informations optionnelles sur l\'article', es: 'Información opcional del artículo', nl: 'Optionele item informatie' },
  'barcode.addToInventory': { en: 'Add to Inventory', fr: 'Ajouter à l\'inventaire', es: 'Agregar al inventario', nl: 'Toevoegen aan voorraad' },
  'barcode.pleaseGenerate': { en: 'Please generate a', fr: 'Veuillez générer un', es: 'Por favor genere un', nl: 'Genereer een' },
  'barcode.first': { en: 'first', fr: 'd\'abord', es: 'primero', nl: 'eerst' },
  'barcode.createdSuccess': { en: 'Item created successfully with barcode!', fr: 'Article créé avec succès avec code-barres !', es: '¡Artículo creado con éxito con código de barras!', nl: 'Item succesvol aangemaakt met barcode!' },
  'barcode.labelTitle': { en: 'Inventory Item Label', fr: 'Étiquette d\'article d\'inventaire', es: 'Etiqueta de artículo de inventario', nl: 'Voorraad item label' },
  'barcode.item': { en: 'Item', fr: 'Article', es: 'Artículo', nl: 'Item' },
  'barcode.newItem': { en: 'New Item', fr: 'Nouvel article', es: 'Nuevo artículo', nl: 'Nieuw item' },
  'barcode.general': { en: 'General', fr: 'Général', es: 'General', nl: 'Algemeen' },

  // Common messages and labels
  'common.required': { en: 'Please fill in required fields', fr: 'Veuillez remplir les champs obligatoires', es: 'Por favor complete los campos requeridos', nl: 'Vul de verplichte velden in' },
  'common.success': { en: 'Success', fr: 'Succès', es: 'Éxito', nl: 'Succes' },
  'common.error': { en: 'Error', fr: 'Erreur', es: 'Error', nl: 'Fout' },
  'common.confirmDelete': { en: 'Are you sure you want to delete this item?', fr: 'Êtes-vous sûr de vouloir supprimer cet élément ?', es: '¿Está seguro de que desea eliminar este elemento?', nl: 'Weet u zeker dat u dit item wilt verwijderen?' },
  'common.updated': { en: 'Item updated successfully!', fr: 'Article mis à jour avec succès !', es: '¡Artículo actualizado con éxito!', nl: 'Item succesvol bijgewerkt!' },
  'common.added': { en: 'Item added successfully!', fr: 'Article ajouté avec succès !', es: '¡Artículo agregado con éxito!', nl: 'Item succesvol toegevoegd!' },
  'common.deleted': { en: 'Item deleted successfully!', fr: 'Article supprimé avec succès !', es: '¡Artículo eliminado con éxito!', nl: 'Item succesvol verwijderd!' },
  'common.failed': { en: 'Operation failed', fr: 'Opération échouée', es: 'Operación fallida', nl: 'Operatie mislukt' },
  'common.scanner': { en: 'Scanner', fr: 'Scanner', es: 'Escáner', nl: 'Scanner' },
  'common.autoScanner': { en: 'Auto Scanner', fr: 'Scanner automatique', es: 'Escáner automático', nl: 'Auto scanner' },
  'common.batch': { en: 'Batch/Barcode', fr: 'Lot/Code-barres', es: 'Lote/Código de barras', nl: 'Batch/Barcode' },
  'common.dangerCategory': { en: 'Danger Category', fr: 'Catégorie de danger', es: 'Categoría de peligro', nl: 'Gevarencategorie' },
  'common.optional': { en: 'optional', fr: 'optionnel', es: 'opcional', nl: 'optioneel' },
  'common.buyPrice': { en: 'Buy Price', fr: 'Prix d\'achat', es: 'Precio de compra', nl: 'Inkoopprijs' },
  'common.sellPrice': { en: 'Sell Price', fr: 'Prix de vente', es: 'Precio de venta', nl: 'Verkoopprijs' },
  'common.stats': { en: 'Quick Stats', fr: 'Statistiques rapides', es: 'Estadísticas rápidas', nl: 'Snelle statistieken' },
  'common.of': { en: 'of', fr: 'de', es: 'de', nl: 'van' },
  'common.showing': { en: 'Showing', fr: 'Affichage', es: 'Mostrando', nl: 'Toont' },
  'common.results': { en: 'results', fr: 'résultats', es: 'resultados', nl: 'resultaten' },
  'common.noResults': { en: 'No items match your search', fr: 'Aucun article ne correspond à votre recherche', es: 'Ningún artículo coincide con su búsqueda', nl: 'Geen items komen overeen met uw zoekopdracht' },
  'common.startAdding': { en: 'Start by adding your first item!', fr: 'Commencez par ajouter votre premier article !', es: '¡Comience agregando su primer artículo!', nl: 'Begin met het toevoegen van uw eerste item!' },
  'common.reference': { en: 'Reference #', fr: 'Référence n°', es: 'Referencia n°', nl: 'Referentie #' },
  'common.supplier': { en: 'Supplier', fr: 'Fournisseur', es: 'Proveedor', nl: 'Leverancier' },
  'common.customer': { en: 'Customer', fr: 'Client', es: 'Cliente', nl: 'Klant' },
  'common.notes': { en: 'Notes', fr: 'Notes', es: 'Notas', nl: 'Notities' },
  'common.selectItem': { en: 'Select Item', fr: 'Sélectionner l\'article', es: 'Seleccionar artículo', nl: 'Item selecteren' },
  'common.addItems': { en: 'Add Items', fr: 'Ajouter des articles', es: 'Agregar artículos', nl: 'Items toevoegen' },
  'common.removeItem': { en: 'Remove', fr: 'Retirer', es: 'Eliminar', nl: 'Verwijderen' },
  'common.shipmentItems': { en: 'Shipment Items', fr: 'Articles de l\'expédition', es: 'Artículos del envío', nl: 'Zending items' },
  'common.noItemsAdded': { en: 'No items added to shipment yet', fr: 'Aucun article ajouté à l\'expédition', es: 'Aún no se han agregado artículos al envío', nl: 'Nog geen items toegevoegd aan zending' },
  'common.createShipment': { en: 'Create Shipment', fr: 'Créer l\'expédition', es: 'Crear envío', nl: 'Zending maken' },
  'common.newShipment': { en: 'New Shipment', fr: 'Nouvelle expédition', es: 'Nuevo envío', nl: 'Nieuwe zending' },
  'common.close': { en: 'Close', fr: 'Fermer', es: 'Cerrar', nl: 'Sluiten' },
  'common.viewOnly': { en: 'View Only Mode', fr: 'Mode lecture seule', es: 'Modo solo lectura', nl: 'Alleen-lezen modus' },
  'common.viewerAccess': { en: 'You have viewer access. Contact your administrator.', fr: 'Accès en lecture seule. Contactez votre administrateur.', es: 'Acceso de solo lectura. Contacte a su administrador.', nl: 'U heeft alleen-lezen toegang. Neem contact op met uw beheerder.' },
  'common.selectItemsToDispatch': { en: 'Select items with available stock to dispatch', fr: 'Sélectionnez des articles en stock à expédier', es: 'Seleccione artículos con stock disponible para enviar', nl: 'Selecteer items met beschikbare voorraad om te verzenden' },

  // Settings page translations
  'settings.title': { en: 'Settings', fr: 'Paramètres', es: 'Configuración', nl: 'Instellingen' },
  'settings.subtitle': { en: 'Manage your account, company information, and system preferences', fr: 'Gérez votre compte, les informations de l\'entreprise et les préférences système', es: 'Gestiona tu cuenta, información de la empresa y preferencias del sistema', nl: 'Beheer je account, bedrijfsinformatie en systeemvoorkeuren' },
  'settings.profile': { en: 'Profile & Company', fr: 'Profil et entreprise', es: 'Perfil y empresa', nl: 'Profiel & Bedrijf' },
  'settings.appearance': { en: 'Appearance', fr: 'Apparence', es: 'Apariencia', nl: 'Uiterlijk' },
  'settings.backup': { en: 'Backup & Data', fr: 'Sauvegarde et données', es: 'Copia de seguridad y datos', nl: 'Back-up & Gegevens' },
  'settings.security': { en: 'Security', fr: 'Sécurité', es: 'Seguridad', nl: 'Beveiliging' },
  'settings.profileTitle': { en: 'Profile & Company Information', fr: 'Informations profil et entreprise', es: 'Información de perfil y empresa', nl: 'Profiel & Bedrijfsinformatie' },
  'settings.companyLogo': { en: 'Company Logo', fr: 'Logo de l\'entreprise', es: 'Logo de la empresa', nl: 'Bedrijfslogo' },
  'settings.uploadLogo': { en: 'Upload Logo', fr: 'Télécharger le logo', es: 'Subir logo', nl: 'Logo uploaden' },
  'settings.uploading': { en: 'Uploading...', fr: 'Téléchargement...', es: 'Subiendo...', nl: 'Uploaden...' },
  'settings.logoFormat': { en: 'PNG format only, max 40MB', fr: 'Format PNG uniquement, max 40 Mo', es: 'Solo formato PNG, máx 40 MB', nl: 'Alleen PNG formaat, max 40MB' },
  'settings.logoSizeError': { en: 'Logo file size must be less than 40MB', fr: 'La taille du fichier logo doit être inférieure à 40 Mo', es: 'El tamaño del archivo del logo debe ser menor a 40 MB', nl: 'Logobestandsgrootte moet kleiner zijn dan 40MB' },
  'settings.logoTypeError': { en: 'Only PNG files are allowed', fr: 'Seuls les fichiers PNG sont autorisés', es: 'Solo se permiten archivos PNG', nl: 'Alleen PNG bestanden zijn toegestaan' },
  'settings.logoSuccess': { en: 'Logo uploaded successfully!', fr: 'Logo téléchargé avec succès !', es: '¡Logo subido con éxito!', nl: 'Logo succesvol geüpload!' },
  'settings.logoFailed': { en: 'Failed to upload logo', fr: 'Échec du téléchargement du logo', es: 'Error al subir el logo', nl: 'Fout bij uploaden logo' },
  'settings.profileSuccess': { en: 'Profile updated successfully!', fr: 'Profil mis à jour avec succès !', es: '¡Perfil actualizado con éxito!', nl: 'Profiel succesvol bijgewerkt!' },
  'settings.profileFailed': { en: 'Failed to update profile', fr: 'Échec de la mise à jour du profil', es: 'Error al actualizar el perfil', nl: 'Fout bij bijwerken profiel' },

  // User Management translations
  'users.title': { en: 'User Management', fr: 'Gestion des utilisateurs', es: 'Gestión de usuarios', nl: 'Gebruikersbeheer' },
  'users.subtitle': { en: 'Manage your team members and their access', fr: 'Gérez les membres de votre équipe et leurs accès', es: 'Gestiona los miembros de tu equipo y sus accesos', nl: 'Beheer je teamleden en hun toegang' },
  'users.addUser': { en: 'Add User', fr: 'Ajouter un utilisateur', es: 'Agregar usuario', nl: 'Gebruiker toevoegen' },
  'users.totalUsers': { en: 'Total Users', fr: 'Total des utilisateurs', es: 'Total de usuarios', nl: 'Totaal gebruikers' },
  'users.active': { en: 'Active', fr: 'Actif', es: 'Activo', nl: 'Actief' },
  'users.inactive': { en: 'Inactive', fr: 'Inactif', es: 'Inactivo', nl: 'Inactief' },
  'users.noUsers': { en: 'No users yet', fr: 'Aucun utilisateur', es: 'Aún no hay usuarios', nl: 'Nog geen gebruikers' },
  'users.addFirstUser': { en: 'Add your first team member to get started', fr: 'Ajoutez votre premier membre', es: 'Agrega tu primer miembro', nl: 'Voeg je eerste teamlid toe' },
  'users.user': { en: 'User', fr: 'Utilisateur', es: 'Usuario', nl: 'Gebruiker' },
  'users.role': { en: 'Role', fr: 'Rôle', es: 'Rol', nl: 'Rol' },
  'users.status': { en: 'Status', fr: 'Statut', es: 'Estado', nl: 'Status' },
  'users.created': { en: 'Created', fr: 'Créé', es: 'Creado', nl: 'Aangemaakt' },
  'users.actions': { en: 'Actions', fr: 'Actions', es: 'Acciones', nl: 'Acties' },
  'users.worker': { en: 'Worker', fr: 'Employé', es: 'Trabajador', nl: 'Werknemer' },
  'users.viewer': { en: 'Viewer', fr: 'Observateur', es: 'Observador', nl: 'Bekijker' },
  'users.createNew': { en: 'Create New User', fr: 'Créer un utilisateur', es: 'Crear usuario', nl: 'Nieuwe gebruiker' },
  'users.fullName': { en: 'Full Name', fr: 'Nom complet', es: 'Nombre completo', nl: 'Volledige naam' },
  'users.email': { en: 'Email', fr: 'Email', es: 'Correo', nl: 'E-mail' },
  'users.password': { en: 'Password', fr: 'Mot de passe', es: 'Contraseña', nl: 'Wachtwoord' },
  'users.minChars': { en: 'Minimum 6 characters', fr: 'Minimum 6 caractères', es: 'Mínimo 6 caracteres', nl: 'Minimaal 6 tekens' },
  'users.selectRole': { en: 'Select Role', fr: 'Sélectionner le rôle', es: 'Seleccionar rol', nl: 'Selecteer rol' },
  'users.creating': { en: 'Creating...', fr: 'Création...', es: 'Creando...', nl: 'Aanmaken...' },
  'users.createUser': { en: 'Create User', fr: 'Créer', es: 'Crear', nl: 'Aanmaken' },
  'users.fillRequired': { en: 'Please fill in all required fields', fr: 'Remplir tous les champs', es: 'Complete todos los campos', nl: 'Vul alle velden in' },
  'users.passwordLength': { en: 'Password must be at least 6 characters', fr: 'Mot de passe minimum 6 caractères', es: 'Contraseña mínimo 6 caracteres', nl: 'Wachtwoord minimaal 6 tekens' },
  'users.createdSuccess': { en: 'User created successfully!', fr: 'Utilisateur créé !', es: '¡Usuario creado!', nl: 'Gebruiker aangemaakt!' },
  'users.emailExists': { en: 'A user with this email already exists', fr: 'Cet email existe déjà', es: 'Este correo ya existe', nl: 'Dit e-mailadres bestaat al' },
  'users.createFailed': { en: 'Failed to create user', fr: 'Échec de création', es: 'Error al crear', nl: 'Fout bij aanmaken' },
  'users.toggleSuccess': { en: 'User status updated!', fr: 'Statut mis à jour !', es: '¡Estado actualizado!', nl: 'Status bijgewerkt!' },
  'users.toggleFailed': { en: 'Failed to update status', fr: 'Échec de mise à jour', es: 'Error al actualizar', nl: 'Fout bij bijwerken' },
  'users.confirmDelete': { en: 'Are you sure you want to delete this user? This action cannot be undone.', fr: 'Supprimer cet utilisateur ?', es: '¿Eliminar este usuario?', nl: 'Gebruiker verwijderen?' },
  'users.deleteSuccess': { en: 'User deleted successfully!', fr: 'Utilisateur supprimé !', es: '¡Usuario eliminado!', nl: 'Gebruiker verwijderd!' },
  'users.deleteFailed': { en: 'Failed to delete user', fr: 'Échec de suppression', es: 'Error al eliminar', nl: 'Fout bij verwijderen' },
  'users.accessDenied': { en: 'Access Denied', fr: 'Accès refusé', es: 'Acceso denegado', nl: 'Toegang geweigerd' },
  'users.adminOnly': { en: 'Only administrators can access user management.', fr: 'Réservé aux administrateurs.', es: 'Solo para administradores.', nl: 'Alleen voor beheerders.' },
  'users.activate': { en: 'Activate', fr: 'Activer', es: 'Activar', nl: 'Activeren' },
  'users.deactivate': { en: 'Deactivate', fr: 'Désactiver', es: 'Desactivar', nl: 'Deactiveren' },

  // Profile Modal translations
  'profile.title': { en: 'My Profile', fr: 'Mon profil', es: 'Mi perfil', nl: 'Mijn profiel' },
  'profile.infoText': { en: 'Update your personal information and password. Your current password is required to save any changes.', fr: 'Mettez à jour vos informations. Mot de passe actuel requis.', es: 'Actualice su información. Contraseña actual requerida.', nl: 'Werk uw informatie bij. Huidig wachtwoord vereist.' },
  'profile.fullName': { en: 'Full Name', fr: 'Nom complet', es: 'Nombre completo', nl: 'Volledige naam' },
  'profile.yourFullName': { en: 'Your full name', fr: 'Votre nom', es: 'Su nombre', nl: 'Uw naam' },
  'profile.changePassword': { en: 'Change Password', fr: 'Changer le mot de passe', es: 'Cambiar contraseña', nl: 'Wachtwoord wijzigen' },
  'profile.newPassword': { en: 'New Password (optional)', fr: 'Nouveau mot de passe', es: 'Nueva contraseña', nl: 'Nieuw wachtwoord' },
  'profile.keepCurrent': { en: 'Leave blank to keep current password', fr: 'Laisser vide pour conserver', es: 'Dejar vacío para mantener', nl: 'Leeg laten om te behouden' },
  'profile.confirmPassword': { en: 'Confirm New Password', fr: 'Confirmer', es: 'Confirmar', nl: 'Bevestigen' },
  'profile.confirmPlaceholder': { en: 'Confirm new password', fr: 'Confirmer le mot de passe', es: 'Confirmar contraseña', nl: 'Wachtwoord bevestigen' },
  'profile.currentPassword': { en: 'Current Password (Required)', fr: 'Mot de passe actuel', es: 'Contraseña actual', nl: 'Huidig wachtwoord' },
  'profile.currentPlaceholder': { en: 'Enter your current password to save changes', fr: 'Entrez votre mot de passe', es: 'Ingrese su contraseña', nl: 'Voer uw wachtwoord in' },
  'profile.mustEnterCurrent': { en: 'You must enter your current password to confirm any changes', fr: 'Mot de passe actuel requis', es: 'Contraseña actual requerida', nl: 'Huidig wachtwoord vereist' },
  'profile.saveChanges': { en: 'Save Changes', fr: 'Enregistrer', es: 'Guardar', nl: 'Opslaan' },
  'profile.enterCurrentPassword': { en: 'Please enter your current password to confirm changes', fr: 'Entrez votre mot de passe', es: 'Ingrese su contraseña', nl: 'Voer uw wachtwoord in' },
  'profile.passwordsNoMatch': { en: 'New passwords do not match', fr: 'Mots de passe différents', es: 'Contraseñas no coinciden', nl: 'Wachtwoorden komen niet overeen' },
  'profile.passwordTooShort': { en: 'New password must be at least 8 characters', fr: 'Minimum 8 caractères', es: 'Mínimo 8 caracteres', nl: 'Minimaal 8 tekens' },
  'profile.sessionExpired': { en: 'Session expired. Please login again.', fr: 'Session expirée.', es: 'Sesión expirada.', nl: 'Sessie verlopen.' },
  'profile.verifyFailed': { en: 'Failed to verify user', fr: 'Échec de vérification', es: 'Error de verificación', nl: 'Verificatie mislukt' },
  'profile.incorrectPassword': { en: 'Current password is incorrect', fr: 'Mot de passe incorrect', es: 'Contraseña incorrecta', nl: 'Wachtwoord onjuist' },
  'profile.updateSuccess': { en: 'Profile updated successfully!', fr: 'Profil mis à jour !', es: '¡Perfil actualizado!', nl: 'Profiel bijgewerkt!' },
  'profile.updateFailed': { en: 'Failed to update profile', fr: 'Échec de mise à jour', es: 'Error al actualizar', nl: 'Fout bij bijwerken' },

  // Payment Terminal additional translations
  'payment.itemNeedsPrice': { en: 'Item must have a sell price to be added to cart', fr: 'L\'article doit avoir un prix de vente', es: 'El artículo debe tener precio de venta', nl: 'Item moet een verkoopprijs hebben' },
  'payment.notEnoughStock': { en: 'Cannot add more items than available in inventory', fr: 'Stock insuffisant', es: 'Stock insuficiente', nl: 'Onvoldoende voorraad' },
  'payment.exceedsInventory': { en: 'Cannot exceed available inventory', fr: 'Dépasse le stock disponible', es: 'Excede el inventario', nl: 'Overschrijdt beschikbare voorraad' },
  'payment.itemNotFound': { en: 'Item not found in inventory', fr: 'Article non trouvé', es: 'Artículo no encontrado', nl: 'Item niet gevonden' },
  'payment.cartEmpty': { en: 'Cart is empty', fr: 'Panier vide', es: 'Carrito vacío', nl: 'Winkelwagen is leeg' },
  'payment.enterCustomerName': { en: 'Please enter customer name', fr: 'Entrez le nom du client', es: 'Ingrese nombre del cliente', nl: 'Voer klantnaam in' },
  'payment.processingFailed': { en: 'Payment processing failed. Please try again.', fr: 'Échec du paiement', es: 'Error en el pago', nl: 'Betaling mislukt' },
  'payment.hideDetails': { en: 'Hide Details', fr: 'Masquer', es: 'Ocultar', nl: 'Verbergen' },
  'payment.addDetails': { en: 'Add Details', fr: 'Ajouter', es: 'Agregar', nl: 'Toevoegen' },
  'payment.createInvoice': { en: 'Create Invoice', fr: 'Créer facture', es: 'Crear factura', nl: 'Factuur maken' },
  'payment.processPayment': { en: 'Process Payment', fr: 'Traiter paiement', es: 'Procesar pago', nl: 'Betaling verwerken' },
  'payment.scanProductBarcode': { en: 'Scan Product Barcode', fr: 'Scanner le code-barres', es: 'Escanear código de barras', nl: 'Scan productbarcode' },
  'payment.customerName': { en: 'Customer name', fr: 'Nom du client', es: 'Nombre del cliente', nl: 'Klantnaam' },
  'payment.customerAddress': { en: 'Customer address', fr: 'Adresse du client', es: 'Dirección del cliente', nl: 'Klantadres' },
  'payment.emailAddress': { en: 'Email address', fr: 'Adresse email', es: 'Correo electrónico', nl: 'E-mailadres' },

  // In-house Shipment
  'inhouse.showOutOfStock': { en: 'Show out of stock', fr: 'Afficher rupture de stock', es: 'Mostrar sin stock', nl: 'Toon niet op voorraad' },
  'inhouse.viewVariants': { en: 'View variants', fr: 'Voir les variantes', es: 'Ver variantes', nl: 'Bekijk varianten' },
  'inhouse.outOfStock': { en: 'Out of stock', fr: 'Rupture de stock', es: 'Sin stock', nl: 'Niet op voorraad' },
  'inhouse.selectProducts': { en: 'Select Products', fr: 'Sélectionner des produits', es: 'Seleccionar productos', nl: 'Producten selecteren' },
  'inhouse.groupedView': { en: 'Grouped', fr: 'Groupé', es: 'Agrupado', nl: 'Gegroepeerd' },
  'inhouse.allProductsView': { en: 'All products', fr: 'Tous les produits', es: 'Todos los productos', nl: 'Alle producten' },
  'inhouse.noMatchingProducts': { en: 'No matching products', fr: 'Aucun produit correspondant', es: 'Sin productos coincidentes', nl: 'Geen overeenkomende producten' },
  'inhouse.cartEmptyHint': { en: 'Select a product group or scan a barcode to add items', fr: 'Sélectionnez un groupe ou scannez un code-barres', es: 'Seleccione un grupo o escanee un código', nl: 'Selecteer een productgroep of scan een barcode' },

  // Shopify Integration
  'shopify.title': { en: 'Shopify Integration', fr: 'Intégration Shopify', es: 'Integración Shopify', nl: 'Shopify Integratie' },
  'shopify.subtitle': { en: 'Connect your Shopify store to sync inventory', fr: 'Connectez votre boutique Shopify pour synchroniser l\'inventaire', es: 'Conecta tu tienda Shopify para sincronizar el inventario', nl: 'Verbind je Shopify-winkel om voorraad te synchroniseren' },
  'shopify.connect': { en: 'Connect Shopify Store', fr: 'Connecter la boutique Shopify', es: 'Conectar tienda Shopify', nl: 'Shopify-winkel verbinden' },
  'shopify.disconnect': { en: 'Disconnect', fr: 'Déconnecter', es: 'Desconectar', nl: 'Ontkoppelen' },
  'shopify.connected': { en: 'Connected', fr: 'Connecté', es: 'Conectado', nl: 'Verbonden' },
  'shopify.pushInventory': { en: 'Push Inventory', fr: 'Pousser l\'inventaire', es: 'Enviar inventario', nl: 'Voorraad verzenden' },
  'shopify.productMapping': { en: 'Product Mapping', fr: 'Mappage de produits', es: 'Mapeo de productos', nl: 'Product mapping' }
};

export function translate(key: string, language: Language): string {
  const translation = translations[key];
  if (!translation) {
    console.warn(`Translation missing for key: ${key}`);
    return key;
  }
  return translation[language] || translation.en;
}
